// Module
var code = "<div class=\"exception\"> <div class=\"text-with-icon\"> <span class=\"exception-icon\"></span> <strong>Error Saving Component</strong> </div> <p class=\"exception-message\">{{message}}</p> </div> <div class=\"details\"> Please fix the errors and click \"Save\" again. </div> ";
// Exports
export default code;